import React from 'react'
import _ from 'lodash'
import { Accordion, Table } from 'camino-react'

const timesheetSum = attribute => timesheets => _.round(_.sumBy(timesheets, attribute), 2)
const deductableTimesheetSum = timesheets => _.round(_.sum(_.map(timesheets, timesheet => (timesheet.duration_hours - (timesheet.utilization_deductable_minutes / 60)))), 2)
const timesheetSumHours = timesheetSum('duration_hours')
const timesheetSumAmount =
  timesheets => _.round(_.sumBy(timesheets,
    ({ duration_hours: hours, hourly_rate: rate }) => hours * rate), 2)

const filterChargeableTimesheets =
  timesheets => _.filter(timesheets, timesheet => timesheet.chargeable && timesheet.chargeable_ticket)
const filterNonChargeableTimesheets =
  timesheets => _.filter(timesheets, timesheet => !(timesheet.chargeable && timesheet.chargeable_ticket))

const UtilizationReportAccordion = ({ data }) => {
  const { groupedTimesheets } = data
  // timesheets are grouped by Team name

  const teamData = _.map(groupedTimesheets, (teamTimesheets, teamName) => {
    const teamChargeableTimesheets = filterChargeableTimesheets(teamTimesheets)
    const teamNonChargeableTimesheets = filterNonChargeableTimesheets(teamTimesheets)

    const timesheetsByUser = _.groupBy(teamTimesheets, 'user_name')
    const userData = _.map(timesheetsByUser, (userTimesheets, userName) => {
      const userChargeableTimesheets = filterChargeableTimesheets(userTimesheets)
      const userNonChargeableTimesheets = filterNonChargeableTimesheets(userTimesheets)

      return {
        userName,
        totalHours: timesheetSumHours(userTimesheets),
        totalHoursWithDeducted: deductableTimesheetSum(userTimesheets),
        totalChargeableHours: timesheetSumHours(userChargeableTimesheets),
        totalChargeableAmount: timesheetSumAmount(userChargeableTimesheets),
        totalNonChargeableHours: timesheetSumHours(userNonChargeableTimesheets),
        totalNonChargeableAmount: timesheetSumAmount(userNonChargeableTimesheets)
      }
    })

    return {
      teamName,
      totalHours: timesheetSumHours(teamTimesheets),
      totalHoursWithDeducted: deductableTimesheetSum(teamTimesheets),
      totalChargeableHours: timesheetSumHours(teamChargeableTimesheets),
      totalChargeableAmount: timesheetSumAmount(teamChargeableTimesheets),
      totalNonChargeableHours: timesheetSumHours(teamNonChargeableTimesheets),
      totalNonChargeableAmount: timesheetSumAmount(teamNonChargeableTimesheets),
      userData
    }
  })

  const utilizationColumns = [
    { text: 'Total Hours', accessor: 'totalHours' },
    { text: 'Total with deducted', accessor: 'totalHoursWithDeducted' },
    { text: 'Total Chargeable Hours', accessor: 'totalChargeableHours' },
    { text: 'Total Chargeable Amount', accessor: 'totalChargeableAmount' },
    { text: 'Total Non-Chargeable Hours', accessor: 'totalNonChargeableHours' },
    { text: 'Total Non-Chargeable Amount', accessor: 'totalNonChargeableAmount' }
  ]

  const accordionDetailsArray = _.map(teamData, ({
    teamName,
    totalHours,
    totalHoursWithDeducted,
    totalChargeableHours,
    totalChargeableAmount,
    totalNonChargeableHours,
    totalNonChargeableAmount,
    userData
  }) => ({
    title: teamName,
    subTitle: (
      <>
        <strong>
          Total hours
        </strong>
        {` ${totalHours} `}
        <strong>
          With deducted
        </strong>
        {` ${totalHoursWithDeducted} `}
        <strong>
          Total chargeable hours
        </strong>
        {` ${totalChargeableHours} `}
        <strong>
          Total chargeable amount
        </strong>
        {` ${totalChargeableAmount} `}
        <strong>
          Total non-chargeable hours
        </strong>
        {` ${totalNonChargeableHours} `}
        <strong>
          Total non-chargeable amount
        </strong>
        {` ${totalNonChargeableAmount} `}
      </>
    ),
    content: (
      <Table
        columns={utilizationColumns}
        data={userData}
        localStoragePrefix="UtilizationReportAccordionItems"
      />
    )
  }))

  return (
    <div>
      <Accordion>
        {accordionDetailsArray}
      </Accordion>
    </div>
  )
}

export default UtilizationReportAccordion
